import React from "react";

const LinkContext = React.createContext(null);
export default LinkContext;
